:host {
  display: block;
  max-width: 100%;
}

gz-single-select-complex[id='user-details-selection'] {
  --select-width: 100%;
}

.category-container {
  height: 40px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }

  &:hover {
    background: var(--chart-050-hover);
    cursor: pointer;
  }

  .icon {
    font-size: var(--header-font-size-large);
  }

  gz-text,
  .icon {
    color: var(--chart-300-icon-buttons);
  }

  .text-container {
    min-width: 0;
    line-height: 1;
  }

  .number {
    padding-left: calc(var(--spacer) - 6px);
  }
}

gz-single-select-complex[id='user-details-selection'] {
  --dropdown-max-width: 100%;
  --dropdown-list-width: 100%;
  --dropdown-width: 100%;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}
